import { render, staticRenderFns } from "./RejectModual.vue?vue&type=template&id=beaeffe6"
import script from "./RejectModual.vue?vue&type=script&lang=js"
export * from "./RejectModual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports